var map = {
	"./music-instructions.json": 5306,
	"./music-library-intro2024.json": 5307,
	"./music-library-launch2024.json": 5308,
	"./music-progression.json": 5309,
	"./startSourcesAdvanced.json": 5310,
	"./startSourcesSimple.json": 5311,
	"./startSourcesSimple2.json": 5312,
	"./startSourcesTracks.json": 5313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4913;